import CellArrow1Comp from './components/cellArrow1'
import CellArrow2Comp from './components/cellArrow2'
import CellTextComp from './components/cellText'
import CellParagraphComp from './components/cellParagraph'
import ChoiceRadioComp from './components/choiceRadio'
import ChoiceRadioListComp from './components/choiceRadioList'
import ChoiceCheckListLeftComp from './components/choiceCheckListLeft'
import ChoiceCheckListRightComp from './components/choiceCheckListRight'
import ChoiceSelectorComp from './components/choiceSelector'
import FieldArrow1Comp from './components/fieldArrow1'
import FieldArrow2Comp from './components/fieldArrow2'
import FieldText1Comp from './components/fieldText1'
import FieldText2Comp from './components/fieldText2'
import FieldParagraphComp from './components/fieldParagraph'
import FieldBtnComp from './components/fieldBtn'
import SearchboxComp from './components/searchbox'
import SearchboxEmptyComp from './components/searchboxEmpty'
import SegmentComp from './components/segment'
import EmptyComp from './components/empty'

import PickerComp from './plugins/picker'

export function install (Vue) {
  Vue.component(SegmentComp.name, SegmentComp)
  Vue.component(CellArrow1Comp.name, CellArrow1Comp)
  Vue.component(CellArrow2Comp.name, CellArrow2Comp)
  Vue.component(CellTextComp.name, CellTextComp)
  Vue.component(CellParagraphComp.name, CellParagraphComp)
  Vue.component(ChoiceRadioComp.name, ChoiceRadioComp)
  Vue.component(ChoiceRadioListComp.name, ChoiceRadioListComp)
  Vue.component(ChoiceCheckListLeftComp.name, ChoiceCheckListLeftComp)
  Vue.component(ChoiceCheckListRightComp.name, ChoiceCheckListRightComp)
  Vue.component(ChoiceSelectorComp.name, ChoiceSelectorComp)
  Vue.component(FieldArrow1Comp.name, FieldArrow1Comp)
  Vue.component(FieldArrow2Comp.name, FieldArrow2Comp)
  Vue.component(FieldText1Comp.name, FieldText1Comp)
  Vue.component(FieldText2Comp.name, FieldText2Comp)
  Vue.component(FieldParagraphComp.name, FieldParagraphComp)
  Vue.component(FieldBtnComp.name, FieldBtnComp)
  Vue.component(SearchboxComp.name, SearchboxComp)
  Vue.component(SearchboxEmptyComp.name, SearchboxEmptyComp)
  Vue.component(EmptyComp.name, EmptyComp)

  Vue.$bmuiPicker = Vue.prototype.$bmuiPicker = PickerComp
}

// install包装函数
function wrapInstall (vueComponent) {
  return {
    install (Vue) {
      Vue.component(vueComponent.name, vueComponent)
    }
  }
}

function wrapInstallForStatic (compName, vueComponent) {
  return {
    install (Vue) {
      Vue[compName] = Vue.prototype[compName] = vueComponent
    }
  }
}

export default { install }

export const CellArrow1 = wrapInstall(CellArrow1Comp)
export const CellArrow2 = wrapInstall(CellArrow2Comp)
export const CellText = wrapInstall(CellTextComp)
export const CellParagraph = wrapInstall(CellParagraphComp)
export const ChoiceRadio = wrapInstall(ChoiceRadioComp)
export const ChoiceRadioList = wrapInstall(ChoiceRadioListComp)
export const ChoiceCheckListLeft = wrapInstall(ChoiceCheckListLeftComp)
export const ChoiceCheckListRight = wrapInstall(ChoiceCheckListRightComp)
export const ChoiceSelector = wrapInstall(ChoiceSelectorComp)
export const FieldArrow1 = wrapInstall(FieldArrow1Comp)
export const FieldArrow2 = wrapInstall(FieldArrow2Comp)
export const FieldText1 = wrapInstall(FieldText1Comp)
export const FieldText2 = wrapInstall(FieldText2Comp)
export const FieldParagraph = wrapInstall(FieldParagraphComp)
export const FieldBtn = wrapInstall(FieldBtnComp)
export const Searchbox = wrapInstall(SearchboxComp)
export const SearchboxEmpty = wrapInstall(SearchboxEmptyComp)
export const Segment = wrapInstall(SegmentComp)
export const Empty = wrapInstall(EmptyComp)
export const Picker = wrapInstallForStatic('$bmuiPicker', PickerComp)
